export const isChildAccessible = (child, isAllowed) => {
  if (child?.onClick) return true;
  return child?.to && isAllowed(child.to);
};
